import curdGenerator from "./curdGenerator";

export const opd = [
  {
    module: "OPD",
    children: [
      {
        module: "Transactions",
        children: [
          curdGenerator("OPD Registration"),
          curdGenerator("OPD Charges"),
          curdGenerator("OPD Refund"),
          curdGenerator("OPD Prescription"),
          curdGenerator("Patient Search"),
          curdGenerator("Medical Certificate")
        ]
      },
      {
        module: "Reports",
        children: [
          {
            module: "OPD Registration Report",
            permission: "opdregistrationreport",
            children: []
          },
          {
            module: "Area Wise OPD Registration Report",
            permission: "areawiseopdregistrationreport",
            children: []
          },
          {
            module: "Department Wise OPD Registration Report",
            permission: "departmentwiseopdregistrationreport",
            children: []
          },
          {
            module: "Case Wise OPD Registration Report",
            permission: "casewiseopdregistrationreport",
            children: []
          },
          {
            module: "Gender Wise OPD Registration Report",
            permission: "genderwiseopdregistrationreport",
            children: []
          },
          {
            module: "OPD Charges Report",
            permission: "opdchargesreport",
            children: []
          },
          {
            module: "Group Wise Charges Report",
            permission: "groupwisechargesreport",
            children: []
          },
          {
            module: "Emergency Statistics Report",
            permission: "emergencystatisticsreport",
            children: []
          },
          {
            module: "OPD Summary Report",
            permission: "opdsummaryreport",
            children: []
          },
          {
            module: "OPD Refund Report",
            permission: "opdrefundreport",
            children: []
          },
          {
            module: "Estimate For Treatment Report",
            permission: "estimatefortreatmentreport",
            children: []
          }
        ]
      }
    ]
  }
];
